<script setup lang="ts">
import {computed} from "vue";
import {bsModalState, bt, queryParams, topBenefitCategories} from "@/store/bt";
import BTTable from "@/bt/BTTable.vue";

const tables = computed(() => {
  if (queryParams.benefit === 0) {
    return [203, 211, 205]
  }
  return [queryParams.benefit]
})

function openSingleBT(catId: number, sectorId: number): void {
  queryParams.sector = sectorId
  queryParams.benefit = catId
  queryParams.multiDisplay = false
}
</script>

<template>
  <div class="row my-4">
    <div class="col">
      <label for="sector" class="form-label">Select a sector</label>
      <select class="form-select" id="sector" v-model.number="queryParams.sector">
        <option :value="0">All</option>
        <template v-for="sector in bt.sectors">
          <option :value="sector.id">{{ sector.name }}</option>
        </template>
      </select>
    </div>
    <div class="col">
      <label for="top-cat" class="form-label">Select a top category</label>
      <select class="form-select" id="top-cat" v-model.number="queryParams.benefit">
        <option value="0">All</option>
        <option v-for="obj in topBenefitCategories" :value="obj.value">{{ obj.label }}</option>
      </select>
    </div>
    <div class="col align-self-end">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="multi-display"
               v-model="queryParams.multiDisplay">
        <label class="form-check-label" for="multi-display">Toggle Multi Display</label>
      </div>
    </div>
    <div class="col align-self-end">
      <div class="d-flex justify-content-end">
        <button v-if="!bsModalState"
                type="button"
                class="btn btn-outline-dark btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#btFullScreenModal">
          <i class="bi bi-arrows-fullscreen"></i>
        </button>
      </div>
    </div>
  </div>
  <div v-if="queryParams.multiDisplay" class="bt__multidisplay">
    <div v-for="item in topBenefitCategories" :key="item.value" class="bt__multidisplay-benefit">
      <h2>{{ item.label }}</h2>
      <template v-for="sector in bt.sectors">
        <div class="bt__mutlidisplay-sector">
          <h3>{{ sector.name }}</h3>
          <BTTable thumbnail :cat-id="item.value" :sector-id="sector.id" @open-modal="openSingleBT"/>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="bt__grid">
    <template v-for="catId in tables" :key="catId">
      <div class="table-wrapper">
        <BTTable :cat-id="catId"/>
      </div>
    </template>
  </div>
</template>

<style>
.bt__multidisplay {
  .bt__mutlidisplay-sector {
    table.thumbnail {
      thead {
        /** No sticky header for multi display */
        position: static;
      }
    }
  }
}
</style>

<style scoped>
.bt__multidisplay {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 4rem;

  .bt__multidisplay-benefit {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span 6;
    background-color: #67a2c1;
    gap: 1rem;

    h2 {
      color: white;
      text-align: center;
      margin-top: 1rem;
    }

    &:nth-child(even) {
      background-color: #1f497d;
    }
  }

  .bt__mutlidisplay-sector {
    padding: 1rem 3rem;

    h3 {
      color: white;
    }
    table.thumbnail {
      zoom: 35%;
      cursor: zoom-in;
    }
  }
}

.bt__grid {
  /*display: grid;*/
  /*grid-template-columns: repeat(auto-fill, minmax(1200px, 1fr));*/
  /*gap: 1rem;*/
}

.table-wrapper {
  max-width: 100%;
  overflow-x: scroll;
}
</style>
